<script lang="ts" setup>
import EventSourceForm from '@/components/events/EventSourceForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { EventsActions, EventsState } from '@/stores/events.store';
import { EventSource } from '@/models/event-source.model';
import { useEvents, Event } from '@/services/events.composable';
import ListFilter from '../common/ListFilter.vue';

const store = useStore<ShiftCMSState & { ev: EventsState }>();
const sources = computed<EventSource[]>(() => store.state.ev.sources);
const events = useEvents();

const update = () => {
  store.dispatch(EventsActions.GetEventSources);
};

onMounted(() => {
  update();
  events.on(Event.LanguageChanged, update);
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
  events.off(Event.LanguageChanged, update);
});

const editEventSource = (_: Event, { item }: { item: EventSource }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(EventSourceForm),
    data: item,
  });
};

const addEventSource = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(EventSourceForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Name', key: 'name', width: '20%' },
  { title: 'URL', key: 'url', width: '25%' },
  { title: 'Last run', key: 'lastSuccessfulRun', width: '15%' },
  { title: 'Events', key: 'lastEventCount', width: '5%' },
  { title: 'State', key: 'translated', width: '10%' },
];

const filter = ref<string>('');
const filterTitle = ref<string>('');
const filteredItems = computed<EventSource[]>(() => {
  return sources.value.filter((v: EventSource) => {
    if (filterTitle.value) {
      return [v.url]
        .map((s) => s.toLowerCase())
        .join('')
        .includes(filterTitle.value);
    }

    return true;
  });
});

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filter.value = filters.filter;
  filterTitle.value = filters.filterTitle;

  console.log(filters.filter, filters.filterTitle);
}
</script>

<template>
  <v-container>
    <h2>Event Sources</h2>
    <ListFilter dense :options="[]" @filter="updateFilter" />
    <v-data-table
      density="compact"
      @click:row="editEventSource"
      :headers="headers"
      :items="filteredItems"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.creationDate="{ value }">
        {{ format(value, 'do MMMM yyyy - HH:mm') }}
      </template>
      <template v-slot:item.lastSuccessfulRun="{ value }">
        {{ value ? format(value, 'do MMMM yyyy - HH:mm') : '-' }}
      </template>
      <template v-slot:item.translated="{ item }">
        <v-icon icon="mdi-eye-check" color="success" v-if="item.enabled" />
        <v-icon icon="mdi-eye-outline" color="warning" v-else />
      </template>
    </v-data-table>

    <v-btn @click="addEventSource" color="success">Add Event Source</v-btn
    >&nbsp;
  </v-container>
</template>
